import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Paginator } from 'src/app/shared/models/grid.model';
import { AdhocListLine } from '../models/wizard.model';

export const LoadAdhocListLineColumns = createAction(
  '[Adhoc List Line]: Load Columns',
  props<{ columns: { [label: string]: string } }>(),
);

export const CloseAdhocListLineModal = createAction('[Adhoc List Line]: Close Modal');

export const LoadAdhocListLineInit = createAction('[Adhoc List Line]: AdhocListLine Init');

export const LoadAdhocListLineSuccess = createAction(
  '[Adhoc List Line]: AdhocListLine Success',
  props<{ data: AdhocListLine[] }>(),
);
export const LoadAdhocListLineFailure = createAction(
  '[Adhoc List Line]: AdhocListLine Success',
  props<{ error: HttpErrorResponse }>(),
);

export const LoadAdhocListLineCountInit = createAction('[Adhoc List Line]: AdhocListLine Count');

export const LoadAdhocListLineCountSuccess = createAction(
  '[Adhoc List Line]: AdhocListLine Count Success',
  props<{ count: number }>(),
);

export const LoadAdhocListLineCountFailure = createAction(
  '[Adhoc List Line]: AdhocListLine Count Failure',
  props<{ error: HttpErrorResponse }>(),
);

export const PagingChanged = createAction(
  '[Adhoc List Line]: Paging Changed',
  props<{ paginator: Paginator }>(),
);
